module.exports = __webpack_public_path__ + "static/img/sl05.de76c5f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/sl05.png
// module id = rCcF
// module chunks = 0